"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTimeMultiplierOverride = exports.timeMultiplier = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
let _timeMultiplierOverride;
let _timeMultiplier;
/**
 * Used to adjust time value of important timers.
 * Can be used to slow things down, like when stepping through code with a debugger to avoid script timeing out, or to speed
 *  things up, such as when testing suspend/timeout and you want to trigger it faster.
 * @returns {number}
 */
function timeMultiplier(baseVal) {
    if (!_timeMultiplier) {
        // todo: where to grab value if in browser?
        _timeMultiplier = _asNumberElseOne(typeof process === 'undefined' ? 1 : process.env[constants_iso_1.EnvVarName.TimeMultiplierForDebugger]);
    }
    return (_timeMultiplierOverride || _timeMultiplier) * baseVal;
}
exports.timeMultiplier = timeMultiplier;
function setTimeMultiplierOverride(val) {
    _timeMultiplierOverride = val;
}
exports.setTimeMultiplierOverride = setTimeMultiplierOverride;
function _asNumberElseOne(val) {
    try {
        const res = parseInt(val, 10);
        if (isNaN(res)) {
            return 1;
        }
        else {
            return res;
        }
    }
    catch (err) {
        return 1;
    }
}
//# sourceMappingURL=time-multiplier.js.map